import { useState } from 'react'
import { RouterProvider } from 'react-router/dom'
import { getBtokHeaderInfo, getBtokPlatform, getCurrentUserName } from '@/utils/native/func'
import { GlobalContext } from './context/GlobalContext'
import router from './router'

export default function App() {
  // 从 URL 中获取 parentTGID
  const url = window.location.href
  const params = new URLSearchParams(url.split('?')[1])
  const parentTGID = params.get('tgId') ?? undefined

  const [username] = useState(() => {
    return getCurrentUserName() || ''
  })

  const platformMap = {
    stage: 'ANDROID_H5',
    armDev: 'ANDROID_H5',
    preRelease: 'ANDROID_H5',
    official: 'ANDROID_H5',
    google_play: 'GOOGLE_H5',
    huawei: 'ANDROID_H5',
    xiaomi: 'ANDROID_H5',
    oppo: 'ANDROID_H5',
    vivo: 'ANDROID_H5',
    Btok_iOS: 'IOS_H5',
  } as const

  type BtokPlatformKey = keyof typeof platformMap

  const [platform] = useState(() => {
    const platformKey = getBtokPlatform() as BtokPlatformKey
    return platformMap[platformKey]
  })

  const [[tgid, language]] = useState(() => {
    const info = getBtokHeaderInfo()
    return [info.tgid, info['Accept-Language']]
  })

  return (
    <GlobalContext.Provider value={{ username, platform, language, tgid, parentTGID }}>
      <RouterProvider router={router} />
    </GlobalContext.Provider>
  )
}
